// extracted by mini-css-extract-plugin
export var banner = "_su-0";
export var settingRow = "_su-2";
export var titleIcon = "_su-1";